import { render, staticRenderFns } from "./DnLoader.vue?vue&type=template&id=40b04840&scoped=true&"
import script from "./DnLoader.vue?vue&type=script&lang=js&"
export * from "./DnLoader.vue?vue&type=script&lang=js&"
import style0 from "./DnLoader.vue?vue&type=style&index=0&id=40b04840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b04840",
  null
  
)

export default component.exports